import React from 'react'
import { createPortal } from 'react-dom'
import { Modal } from '@mobi/component-library/Overlays/Modal'
import { layering, spacing } from '@mobi/component-library/Foundations'
import { Button, ButtonColor } from '@mobi/component-library/Base/Buttons'
import styled from '@emotion/styled'

export type InAppMarketingModalProps = {
  isOpen: boolean
  onCancel: () => void
  onButtonClicked: (link: string, buttonIndex: number) => void
  notification: InAppMarketingNotification
}

export type InAppMarketingNotification = {
  imageUrl: string
  buttons: {
    index: number
    text: string
    buttonStyle: ButtonColor
    link: string
  }[]
  headerText: string
  copyText: string
}

export const InAppMarketingModal: React.FC<InAppMarketingModalProps> = ({
  isOpen,
  onCancel,
  onButtonClicked,
  notification,
}) => {
  const orderedActions = notification.buttons.toSorted((a, b) => a.index - b.index)

  return createPortal(
    <Modal
      isOpen={isOpen}
      headerTitle={notification.headerText}
      headerSubtitle={notification.copyText}
      headerImage={<img src={notification.imageUrl} />}
      onDismiss={onCancel}
      zIndex={layering.overlayHigh}
      modalStyle={{ maxWidth: '44rem' }}
      footerComponent={
        <FooterStyled>
          {orderedActions.map(button => (
            <Button
              key={button.index}
              size='md'
              isFullWidth
              color={button.buttonStyle}
              onClick={() => onButtonClicked(button.link, button.index)}
            >
              {button.text}
            </Button>
          ))}
        </FooterStyled>
      }
    />,
    document.body
  )
}

const FooterStyled = styled.div({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: spacing.smx1,
})
